import React from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus, Crown, FileText, Wallet, Users, ChevronRight } from "lucide-react";
import "../Style/Role.css";

const Role = ({ setSelectedRole }) => {
  const navigate = useNavigate();

  const handlePostClick = () => {
    if (typeof setSelectedRole === "function") setSelectedRole("POST");
    navigate("/assign-role");
  };

  const handleRoleClick = (role) => {
    if (typeof setSelectedRole === "function") setSelectedRole(role);
    navigate(`/member-table/${encodeURIComponent(role)}`);
  };

  const roles = [
    { name: "Post", value: "POST", icon: UserPlus, onClick: handlePostClick },
    { name: "Chairman", value: "CHAIRMAN", icon: Crown, onClick: () => handleRoleClick("CHAIRMAN") },
    { name: "Secretary", value: "SECRETARY", icon: FileText, onClick: () => handleRoleClick("SECRETARY") },
    { name: "Treasurer", value: "TREASURER", icon: Wallet, onClick: () => handleRoleClick("TREASURER") },
    { name: "Committee Member", value: "COMMITEE MEMBER", icon: Users, onClick: () => handleRoleClick("COMMITEE MEMBER") },
  ];

  return (
    <div className="role-list-wrapper">
      {roles.map((role, index) => {
        const Icon = role.icon;
        return (
          <button
            key={index}
            className="role-item-btn"
            onClick={role.onClick}
          >
            <div className="role-item-content">
              <div className="role-icon-box">
                <Icon size={16} />
              </div>
            <span className="role-name" style={{ color: "#007BFF" }}>
             {role.name}
            </span>
            </div>
            <ChevronRight size={14} className="role-chevron" />
          </button>
        );
      })}
    </div>
  );
};

export default Role;
